<template>
  <div class="po-product">
    <ProductImage v-if="imageUrl" :src="imageUrl" class="po-product-img" />
    <div v-else class="po-product-img-placeholder">
      <i class="mdi mdi-image-off-outline"></i>
    </div>

    <div v-if="editable" class="po-product-body">
      <div class="po-imei-pill po-product-search">
        <i class="mdi mdi-cellphone po-imei-pill-icon"></i>
        <vue-autosuggest
          class="po-product-suggest"
          :value="searchText"
          :suggestions="suggestions"
          :limit="10"
          :input-props="autosuggestInputProps"
          :get-suggestion-value="getSuggestionValue"
          :should-render-suggestions="shouldRenderSuggestions"
          @input="onInput"
          @selected="onSelected"
          @focus="$emit('focus')"
        >
          <template slot-scope="{ suggestion }">
            <div class="d-flex align-items-start" style="gap: 8px">
              <ProductImage :src="suggestion.item.productImageUrl" />
              <div class="flex-grow-1">
                <div class="text-muted" style="font-size: 11px">
                  {{ suggestion.item.barCode }} · ({{ suggestion.item.productCode }})
                </div>
                <div style="font-size: 13px">{{ suggestion.item.productName }}</div>
                <div
                  v-if="showPrice && suggestion.item.originalPrice != null"
                  class="text-muted"
                  style="font-size: 12px"
                >
                  Giá vốn: {{ formatPrice(suggestion.item.originalPrice) }}
                </div>
              </div>
            </div>
          </template>
        </vue-autosuggest>
      </div>
      <div v-if="productId" class="po-product-code mt-1">
        {{ barCode }} <span class="po-product-code-sub">({{ productCode }})</span>
      </div>
    </div>

    <div v-else class="po-product-body">
      <span class="po-product-code">
        {{ barCode }} <span class="po-product-code-sub">({{ productCode }})</span>
      </span>
      <p class="po-product-name">{{ productName }}</p>
      <span v-if="badge" class="po-badge-same">{{ badge }}</span>
    </div>
  </div>
</template>

<script>
import ProductImage from '@/view/components/products/ProductImage.vue';
import { convertPrice } from '@/utils/common';

export default {
  name: 'ProductionOrderProductCell',
  components: { ProductImage },
  props: {
    productId: { type: [String, Number], default: null },
    productName: { type: String, default: '' },
    productCode: { type: String, default: '' },
    barCode: { type: String, default: '' },
    imageUrl: { type: String, default: '' },
    editable: { type: Boolean, default: false },
    searchText: { type: String, default: '' },
    suggestions: { type: Array, default: () => [{ data: [] }] },
    badge: { type: String, default: '' },
    placeholder: { type: String, default: 'Tìm SP IMEI mới...' },
    showPrice: { type: Boolean, default: true },
  },
  computed: {
    autosuggestInputProps() {
      return {
        class: 'autosuggest__input po-product-suggest-input',
        placeholder: this.placeholder,
      };
    },
  },
  methods: {
    shouldRenderSuggestions(size, loading) {
      return size >= 0 && !loading && Boolean((this.searchText || '').trim());
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.productName;
    },
    formatPrice(value) {
      return convertPrice(value);
    },
    onInput(text) {
      this.$emit('search-input', text);
    },
    onSelected(option) {
      this.$emit('selected', option.item);
    },
  },
};
</script>
